import React, { useState, useRef } from "react";
import { Html } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";

import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/solid";

// InfoPoint Component
const InfoPoint = ({ position, title, description, images, visible, darkMode }) => {
  const [show, setShow] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [popupPosition, setPopupPosition] = useState([0, 0.15, 0]);
  const popupRef = useRef(null);

  useFrame(() => {
    if (popupRef.current) {
      const rect = popupRef.current.getBoundingClientRect();
      let offsetX = popupRef.current.dataset.offsetX || 0;
      let offsetY = popupRef.current.dataset.offsetY || 0;

      // Calculate required adjustments **only if necessary**
      if (rect.left < 0) offsetX = -rect.left + 100;
      if (rect.top < 0) offsetY = -rect.top + 100;
      if (rect.right > window.innerWidth) offsetX = window.innerWidth - rect.right - 100;
      if (rect.bottom > window.innerHeight) offsetY = window.innerHeight - rect.bottom - 100;

      // **Prevent unnecessary updates (Flickering Fix)**
      if (
        offsetX !== Number(popupRef.current.dataset.offsetX) ||
        offsetY !== Number(popupRef.current.dataset.offsetY)
      ) {
        popupRef.current.dataset.offsetX = offsetX;
        popupRef.current.dataset.offsetY = offsetY;
        popupRef.current.style.transform = `translate(${offsetX}px, ${offsetY}px)`;
      }
    }
  });

  // Navigation Functions
  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  if(!visible) return null;
  return (
    <group position={position}>
      {/* 🔶 Sphere as Clickable Marker */}
      <mesh
        onClick={() => setShow(!show)}
        onPointerOver={(e) => e.stopPropagation()}
        scale={visible ? 2 : 0.5}
        renderOrder={100}
        
      >
        <sphereGeometry args={[0.05, 16, 16]} />
        {/* <meshStandardMaterial color={darkMode?"white":"black"} /> */}
        <meshBasicMaterial color={darkMode?"white":"black"} depthTest={true} depthWrite={true} />
      </mesh>

      {/* 🔶 Popup Info Box */}
      {show && (
        <Html position={popupPosition} center>
          <div ref={popupRef} className="popup-container bg-white rounded shadow-lg w-52 text-xs relative">
            {/* 🔹 Image Carousel with Buttons */}
            {images && images.length > 0 && (
              <div className="relative">
                <img
                  src={`${process.env.PUBLIC_URL || ''}${images[currentIndex]}`}
                  // src={images[currentIndex]}
                  alt={title}
                  className="w-full h-32 object-cover rounded-t"
                />
                {/* Left Button */}
                {images.length > 1 && (
                  <button
                    onClick={handlePrev}
                    className="absolute left-1 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-40 text-white p-1 rounded-full shadow-md"
                  >
                    <ChevronLeftIcon className="w-4 h-4" />
                  </button>
                )}
                {/* Right Button */}
                {images.length > 1 && (
                  <button
                    onClick={handleNext}
                    className="absolute right-1 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-40 text-white p-1 rounded-full shadow-md"
                  >
                    <ChevronRightIcon className="w-4 h-4" />
                  </button>
                )}
              </div>
            )}

            {/* 🔹 Text Content */}
            <div className="p-2">
              <h3 className="font-bold text-sm">{title}</h3>
              <p className="text-gray-700">{description}</p>
              <div className="flex justify-end">
                <button
                  className="mt-2 text-xs text-gray-300 p-1 px-2 bg-black rounded"
                  onClick={() => setShow(false)}
                >
                  Chiudi
                </button>
              </div>
            </div>
          </div>
        </Html>
      )}
    </group>
  );
};

export default InfoPoint;
